import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingChange: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public readonly loadingState = this.loadingChange.asObservable();
  constructor() {}

  start(): void {
    this.loadingChange.next(true);
  }
  stop(): void {
    this.loadingChange.next(false);
  }
}
